import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Query } from '@datorama/akita';
import { Tooth } from '@modules/teeth-diagram/models/tooth';
import { RxIntuitiveTeethDiagramState } from '../models';
import { RxIntuitiveTeethDiagramStore } from './rx-intuitive-teeth-diagram-store';
import { IntuitiveBridge } from '../models/intuitive-bridge';

@Injectable()
export class RxIntuitiveTeethDiagramQuery extends Query<RxIntuitiveTeethDiagramState> {
	toothLastTouchedAt$: Observable<Record<number, number>> = this.select(state => state.toothLastTouchedAt);

	selectedToothIds$: Observable<number[]> = this.select(state => state.selectedToothIds);
	dismissedGuidanceBanner$: Observable<boolean> = this.select(state => state.dismissedGuidanceBanner);
	selectedBridge$: Observable<IntuitiveBridge | undefined> = this.select(state => state.selectedBridge);
	selectedBridgeTeeth$: Observable<Tooth[]> = this.selectedBridge$.pipe(map(bridge => bridge?.teeth ?? []));
	isSelectedBridgeSubmitted$: Observable<boolean> = this.select(state => state.isSelectedBridgeSubmitted);

	get toothLastTouchedAt(): Record<number, number> {
		return this.getValue().toothLastTouchedAt;
	}

	get selectedToothIds(): number[] {
		return this.getValue().selectedToothIds;
	}

	get selectedBridge(): IntuitiveBridge | undefined {
		return this.getValue().selectedBridge;
	}

	get selectedBridgeTeeth(): Tooth[] {
		return this.selectedBridge?.teeth ?? [];
	}

	/**
	 * Returns true if the intuitive diagram has unsaved state (bridge selected or teeth edited).
	 */
	getIsDirty(): boolean {
		const state = this.getValue();

		return state.selectedBridge !== undefined || Object.keys(state.toothLastTouchedAt).length > 0;
	}

	constructor(protected store: RxIntuitiveTeethDiagramStore) {
		super(store);
	}
}
